/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCapexDto } from '../../models/backend-actual-capex-dto';
import { BackendPatchedActualCapexRequestDto } from '../../models/backend-patched-actual-capex-request-dto';

export interface MonitoringActualsCapexsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedActualCapexRequestDto;
}

export function monitoringActualsCapexsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCapexsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCapexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCapexsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCapexDto>;
    }),
  );
}

monitoringActualsCapexsPartialUpdate.PATH = '/api/monitoring/actuals/capexs/{id}/';
